var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('history-table',{attrs:{"id":"command-history-list-table","items":_vm.items,"fields":_vm.fields,"is-busy":_vm.isBusy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }